import { Link } from 'react-router-dom';

export function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-white border-t border-blush-200 mt-auto">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {/* Brand */}
          <div>
            <img src="/logo.png" alt="CareCal" className="h-6 w-auto mb-2" />
            <p className="font-body text-sm text-gray-600 mt-2">
              Connecting caregivers with families who need care.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="font-display font-semibold text-gray-900 mb-3">Quick Links</h3>
            <ul className="space-y-2">
              <li>
                <Link
                  to="/about"
                  className="font-body text-sm text-gray-600 hover:text-blush-600 transition-colors"
                >
                  About Us
                </Link>
              </li>
              <li>
                <Link
                  to="/how-it-works"
                  className="font-body text-sm text-gray-600 hover:text-blush-600 transition-colors"
                >
                  How It Works
                </Link>
              </li>
              <li>
                <Link
                  to="/contact"
                  className="font-body text-sm text-gray-600 hover:text-blush-600 transition-colors"
                >
                  Contact
                </Link>
              </li>
            </ul>
          </div>

          {/* Legal */}
          <div>
            <h3 className="font-display font-semibold text-gray-900 mb-3">Legal</h3>
            <ul className="space-y-2">
              <li>
                <Link
                  to="/privacy"
                  className="font-body text-sm text-gray-600 hover:text-blush-600 transition-colors"
                >
                  Privacy Policy
                </Link>
              </li>
              <li>
                <Link
                  to="/terms"
                  className="font-body text-sm text-gray-600 hover:text-blush-600 transition-colors"
                >
                  Terms of Service
                </Link>
              </li>
            </ul>
          </div>
        </div>

        {/* Copyright */}
        <div className="mt-8 pt-8 border-t border-blush-200">
          <p className="font-body text-sm text-gray-600 text-center">
            © {currentYear} CareCal. All rights reserved.
          </p>
        </div>
      </div>
      <div className="h-safe-bottom" aria-hidden="true" />
    </footer>
  );
}
